import type React from 'react';

import { EyeOffIcon, EyeOnIcon } from '@vlabs/icons';
import { IconButton } from '@vlabs/uikit/components/controls/button/icon-button';

import st from './EventTypeVisibilityButton.module.sass';

interface EventTypeVisibilityButtonProps {
  isEnabled: boolean;
  onChange: (isEnabled: boolean) => void;
  testId: string;
}

function EventTypeVisibilityButton({
  isEnabled,
  onChange,
  testId,
}: EventTypeVisibilityButtonProps): React.JSX.Element {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    onChange(!isEnabled);
  };

  return (
    <IconButton
      className={st.Root}
      data-testid={testId}
      icon={isEnabled ? <EyeOnIcon /> : <EyeOffIcon />}
      kind="secondary"
      onClick={handleClick}
      type="button"
      variant="dimmed"
    />
  );
}

export { EventTypeVisibilityButton };
